module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// ./~/symbol-observable/index.js
// module id = 247
// module chunks = 35783957827783 64089156084587 91322373450782 114276838955818